/**
 * Wire Shopify landing forms to the Next.js /api/audit endpoint.
 * Mirrors components/home/audit-form.tsx (validate → loading steps → redirect).
 * Loaded by oddfish-landing-page.liquid via theme assets.
 */
(function () {
  "use strict";

  var cfg = window.ODDFISH_SHOPIFY || {};
  var API_BASE = cfg.API_BASE || "http://localhost:3001";

  var AUDIT_STEPS = [
    "Connecting to server...",
    "Fetching page HTML & headers...",
    "Analyzing meta tags & Open Graph data...",
    "Checking heading structure & hierarchy...",
    "Scanning images, alt tags & formats...",
    "Evaluating internal & external links...",
    "Verifying SSL, HSTS & security headers...",
    "Testing mobile & responsive design...",
    "Detecting structured data & schemas...",
    "Measuring server response & TTFB...",
    "Analyzing render-blocking resources...",
    "Checking third-party script impact...",
    "Evaluating content quality & E-E-A-T...",
    "Checking robots.txt & sitemap.xml...",
    "Analyzing crawlability & indexation...",
    "Detecting site type & platform...",
    "Running ecommerce-specific checks...",
    "Checking keyword rankings...",
    "Auditing Google Business Profile...",
    "Generating AI executive summary...",
    "Calculating category scores...",
    "Compiling audit report...",
  ];

  function readForm(form) {
    var fd = new FormData(form);
    var business = fd.get("business") || fd.get("businessName") || "";
    var turnoverInput = form.querySelector(
      'input[type="radio"][name^="turnover"]:checked'
    );
    return {
      name: String(fd.get("name") || "").trim(),
      email: String(fd.get("email") || "").trim(),
      website: String(fd.get("website") || "").trim(),
      mobile: String(fd.get("mobile") || "").trim(),
      businessName: String(business).trim(),
      turnover: turnoverInput ? turnoverInput.value : undefined,
    };
  }

  function validate(data) {
    var errors = {};
    if (!data.name) errors.name = "Name is required";
    if (!data.email) errors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email))
      errors.email = "Invalid email";
    if (!data.website) errors.website = "Website URL is required";
    if (!data.businessName) errors.businessName = "Business name is required";
    return errors;
  }

  function getRoot(form) {
    return form.closest(".oe-audit-form-root") || form;
  }

  function getVariant(root) {
    return root.getAttribute("data-variant") || "island";
  }

  function buttonClass(variant) {
    return variant === "final" ? "oe-btn-submit-final" : "oe-btn-dark";
  }

  function clearFieldErrors(form) {
    form.querySelectorAll(".oe-field-error").forEach(function (el) {
      el.remove();
    });
  }

  function showFieldErrors(form, errors) {
    clearFieldErrors(form);
    Object.keys(errors).forEach(function (key) {
      var field =
        form.querySelector('[name="' + key + '"]') ||
        (key === "businessName" ? form.querySelector('[name="business"]') : null);
      if (!field) return;
      var msg = document.createElement("p");
      msg.className = "oe-field-error";
      msg.textContent = errors[key];
      field.insertAdjacentElement("afterend", msg);
    });
  }

  function renderLoading(root, website, currentStep) {
    var progress = Math.round(((currentStep + 1) / AUDIT_STEPS.length) * 100);
    root.innerHTML =
      '<div class="oe-audit-status oe-audit-status--loading" role="status" aria-live="polite">' +
      '<div class="oe-audit-spinner" aria-hidden="true"></div>' +
      '<p class="oe-audit-status-title">Analyzing your website</p>' +
      '<p class="oe-audit-status-url"></p>' +
      '<p class="oe-audit-status-step"></p>' +
      '<p class="oe-audit-status-meta"></p>' +
      '<div class="oe-audit-progress"><div class="oe-audit-progress-bar"></div></div>' +
      '<p class="oe-audit-status-pct"></p>' +
      "</div>";
    root.querySelector(".oe-audit-status-url").textContent = website;
    updateLoading(root, currentStep);
  }

  function updateLoading(root, currentStep) {
    var progress = Math.round(((currentStep + 1) / AUDIT_STEPS.length) * 100);
    var stepEl = root.querySelector(".oe-audit-status-step");
    var metaEl = root.querySelector(".oe-audit-status-meta");
    var barEl = root.querySelector(".oe-audit-progress-bar");
    var pctEl = root.querySelector(".oe-audit-status-pct");
    if (stepEl) stepEl.textContent = AUDIT_STEPS[currentStep] || "";
    if (metaEl)
      metaEl.textContent =
        "Step " + (currentStep + 1) + " of " + AUDIT_STEPS.length;
    if (barEl) barEl.style.width = progress + "%";
    if (pctEl) pctEl.textContent = progress + "%";
  }

  function renderError(root, variant, message, onRetry) {
    var btnCls = buttonClass(variant);
    root.innerHTML =
      '<div class="oe-audit-status oe-audit-status--error" role="alert">' +
      '<div class="oe-audit-error-icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor">' +
      '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>' +
      "</svg></div>" +
      '<p class="oe-audit-status-title">Audit Failed</p>' +
      '<p class="oe-audit-status-msg"></p>' +
      '<button type="button" class="' +
      btnCls +
      ' oe-audit-retry">Try Again</button>' +
      "</div>";
    root.querySelector(".oe-audit-status-msg").textContent = message;
    root.querySelector(".oe-audit-retry").addEventListener("click", onRetry);
  }

  function bindForm(form) {
    var root = getRoot(form);
    var variant = getVariant(root);
    var formHTML = form.outerHTML;
    var state = {
      currentStep: 0,
      report: null,
      apiDone: false,
      interval: null,
      finishTimer: null,
    };

    function restoreForm() {
      if (state.interval) clearInterval(state.interval);
      if (state.finishTimer) clearTimeout(state.finishTimer);
      state.interval = null;
      state.finishTimer = null;
      root.innerHTML = formHTML;
      var newForm = root.querySelector("form");
      if (newForm) bindForm(newForm);
    }

    function finishStepsThenRedirect() {
      function tick() {
        if (state.currentStep < AUDIT_STEPS.length - 1) {
          state.currentStep++;
          updateLoading(root, state.currentStep);
          state.finishTimer = setTimeout(tick, 250);
        } else {
          state.finishTimer = setTimeout(function () {
            if (state.report && state.report.id) {
              window.location.href = API_BASE + "/report/" + state.report.id;
            }
          }, 500);
        }
      }
      tick();
    }

    function startStepInterval() {
      state.interval = setInterval(function () {
        if (state.apiDone) {
          clearInterval(state.interval);
          state.interval = null;
          finishStepsThenRedirect();
          return;
        }
        if (state.currentStep < AUDIT_STEPS.length - 3) {
          state.currentStep++;
          updateLoading(root, state.currentStep);
        }
      }, 1800);
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var data = readForm(form);
      var errors = validate(data);
      if (Object.keys(errors).length) {
        showFieldErrors(form, errors);
        return;
      }
      clearFieldErrors(form);

      state.currentStep = 0;
      state.report = null;
      state.apiDone = false;

      renderLoading(root, data.website, 0);
      startStepInterval();

      fetch(API_BASE + "/api/audit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (body) {
              throw new Error(
                (body && body.error) || "Audit failed"
              );
            });
          }
          return res.json();
        })
        .then(function (report) {
          try {
            sessionStorage.setItem(
              "report-" + report.id,
              JSON.stringify(report)
            );
          } catch (_) {}
          state.report = report;
          state.apiDone = true;
        })
        .catch(function (err) {
          if (state.interval) clearInterval(state.interval);
          if (state.finishTimer) clearTimeout(state.finishTimer);
          state.interval = null;
          state.finishTimer = null;
          var msg =
            err && err.message ? err.message : "Something went wrong";
          if (msg === "Load failed" || msg === "Failed to fetch") {
            msg =
              "Could not reach the audit server. Check that API_BASE in oddfish-config.js points to a reachable URL (http://localhost:3001 for local testing).";
          }
          renderError(root, variant, msg, restoreForm);
        });
    });
  }

  function init() {
    document
      .querySelectorAll(
        ".oddfish-embed .oe-audit-form-root form, .oddfish-embed form"
      )
      .forEach(function (form) {
        if (form.dataset.auditBound === "1") return;
        form.dataset.auditBound = "1";
        bindForm(form);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
